<template>
  <div id="page">

    <!-- breadcrumbs -->
    <section class="container-fluid breadcrumbs d-none d-md-block">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="#">Home</a></li>
                <li class="breadcrumb-item active" aria-current="page">{{ $t('views.login.breadcrumbpage') }}</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
    </section>
    <!-- breadcrumbs END -->

    <main id="main" class="">

      <div class="container px-xs-0 beratung">
        <div class="row">
          <div class="login-heading">
            <i aria-hidden="true" class="icon icon--user-solid"></i>
            <div>
              <h1>{{ $t('views.login.breadcrumbpage') }}</h1>
              <!-- <small class="">{{ $t('views.login.loginnote') }}</small> -->
            </div>
          </div>

        </div>
        <div class="row login-content">
          <h2 class="mb-4" style="margin-bottom: 1rem !important" >{{ $t('views.login.logintext') }}</h2>
          <div class="row">
            <div class="col-12 col-lg-4 mb-5 mb-lg-0" style="margin-bottom:1rem!important">
              <div class="mb-4">
                <label class="form-label" for="username">{{ $t('views.login.username') }}</label>
                <input type="text" class="form-control" v-model="username" id="username" autocomplete="off">
              </div>
              <div class="mb-4">
                <label class="form-label" for="password">{{ $t('views.login.password') }}</label>
                <div class="pw-input--wrapper">
                  <input :type="passwordFieldType"  class="form-control" v-model="password" id="password" autocomplete="off" @keyup.enter="login">
                  <i data-target="password" :class="passwordFieldType === 'password' ? 'onb-visible--on': 'onb-visible--off'" class="icon pw-input--switch"
                  :title="passwordFieldType === 'password' ? $t('views.login.showpw'): $t('views.login.hidepw')" @click="togglePassword"
                  :aria-label="passwordFieldType === 'password' ? $t('views.login.showpw') : $t('views.login.hidepw')"
                  ></i>
                </div>
              </div>
              <button class="btn btn-primary-custom mt-4 mb-4 me-4" @click="login">{{ $t('views.login.login') }}</button>
              <div v-if="errorMessage" class="alert alert-danger">{{ errorMessage }}</div> <!-- Error message display -->
              <button class="btn btn-outline-primary-custom mt-4 mb-4 me-4" @click="navigateToRegister">{{ $t('views.login.newaccount') }}</button>
              <div class="mb-5" style="margin-top:1rem ;margin-bottom:0!important">
                  <p>
                      {{ $t('views.login.forgotpw') }}
                      <br>
                      {{ $t('views.login.resetpw') }}
                      <router-link to="/register"> {{ $t('views.login.resetpw1') }}</router-link> {{ $t('views.login.resetpw2') }}
                  </p>
              </div>
            </div>
            <div class="col offset-lg-1">
              <h4 class="mb-4" style="margin-top:0.5rem!important; font-size: 1.2em;">{{ $t('views.login.sometext') }}</h4>
              <ol class="onb-numbered-list">
                <li class="onb-numbered-list--item">
                  <div>
                    {{ $t('views.login.sometext1') }}
                  </div>
                </li>
                <li class="onb-numbered-list--item">
                  <div>
                    {{ $t('views.login.sometext2') }}
                  </div>
                </li>
                <li class="onb-numbered-list--item">
                  <div>
                    {{ $t('views.login.sometext3') }}
                  </div>
                </li>
                <li class="onb-numbered-list--item">
                  <div>
                       {{ $t('views.login.sometext4') }}
                  </div>
                </li>
              </ol>
              <a :href="getMoreLinkText()" class="my-4 d-block">{{ $t('views.login.moreinfo') }}</a>
              <strong v-if="website == 'FAMILIE'">{{ $t('views.login.familienberatung') }} <a href="https://www.frauenberatung.gv.at/">{{ $t('views.login.familienberatung1') }}</a>{{ $t('views.login.registered') }}</strong>
              <strong v-if="website == 'FRAUEN'">{{ $t('views.login.frauenberatung') }} <a href="https://www.familienberatung.gv.at/">{{ $t('views.login.frauenberatung1') }}</a>{{ $t('views.login.registered') }}</strong>
              <strong class="d-block pt-4">{{ $t('views.login.dontsavetext') }}</strong>

            </div>
          </div>
        </div>

      </div> <!-- /container -->


    </main>


  </div> <!-- #page -->
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import AuthService from '../../services/authService';
import { sanitizeUrl } from '@braintree/sanitize-url';

export default defineComponent({
  name: 'AccountLoginView',
  computed: {
  },
  props: {
    moreInfoLink: String
  },
  data() {
    return {
      username: '',
      password: '',
      errorMessage: '',
      passwordFieldType: 'password',
      website: document.body.classList.contains('familie') ? 'FAMILIE' : 'FRAUEN'
    }
  },
  methods: {
    getMoreLinkText() {
      const account = document.getElementById('account');
      if (account) {
        const infoLink = account.getAttribute('data-more-info-link');
        if (infoLink) {
          return sanitizeUrl(infoLink);
        }
      }
      return "";
    },
    togglePassword() {
      this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
    },
    async login() {
      try {
        const userData = await AuthService.login(this.username, this.password);
        this.navigateToAccount();
      } catch (error: any) {
        // "client__login_locked"
        if (error && error.message == "client__login_locked") {
          this.errorMessage = this.$t('common.clientLoginLocked');
        }
        else if(error && error.message== "username_password_combination_error"){
          this.errorMessage = this.$t('common.error.username_password_combination_error')
        }
         else {
          this.errorMessage = error || 'An error occurred during login';
        }
      }
    },
    navigateToAccount() {
      this.$router.push('/');
    },
    navigateToRegister() {
      this.$router.push('/register');
    },
  },
});
</script>
